import React from "react";
import { useLocation } from "react-router-dom";
import { Switch, Route, Redirect } from "react-router-dom";
import VersionChecker from "components/VersionChecker";
import Header from 'components/Header';
import PushNotifications from "components/PushNotifications";
import CreateBooking from "screens/CreateBooking";
import GroupDetails from "screens/GroupDetails";
import GroupCheckIn from "screens/GroupCheckIn";
import Login from "screens/Login";
import Staff from "screens/Staff";
import TenantDetails from "screens/TenantDetails";
import StaffDetails from "screens/StaffDetails";
import ReviewPhotos from "screens/ReviewPhotos";
import Home from "screens/Home";
import Settings from "screens/Settings";
import Cafe from "screens/Cafe";
import CafePanel from "screens/CafePanel";
import Parking from "screens/Parking";
import Rooms from "screens/Rooms";
import RoomDetails from "screens/RoomDetails";
import RoomChange from "screens/RoomChange";
import RoomTypeDetails from "screens/RoomTypeDetails";
import Bookings from "screens/Bookings";
import Reports from "screens/Reports";
import Communications from "screens/Communications";
import SearchResults from "screens/SearchResults";
import NotFoundScreen from "screens/NotFoundScreen";
import Cookies from "js-cookie";

const App = () => {
  const validToken = Cookies.get("token");
  const location = useLocation();
  if (
    location.pathname !== "/login" &&
    location.pathname !== "/forgetPassword"
  ) {
    localStorage.setItem("previousPath", location.pathname);
  }

  return (
    <>
      <VersionChecker />
      {!!validToken ? (
        <>
          <PushNotifications />
          <Header />
          <Switch>
            <Redirect exact from="/" to="/floor" />
            <Route path="/floor" component={Home} />
            <Route path="/settings" component={Settings} />
            <Route path="/cafe" exact component={Cafe} />
            <Route path="/parking" exact component={Parking} />
            <Route path="/bookings" exact component={Bookings} />
            <Route path="/create-booking" exact component={CreateBooking} />
            <Route path="/rooms" component={Rooms} />
            <Route
              path="/room-change/:bookingId"
              exact
              component={RoomChange}
            />
            <Route
              path="/room-details/:roomNumber"
              exact
              component={RoomDetails}
            />
            <Route path="/staff" exact component={Staff} />
            <Route path="/reports" component={Reports} />
            <Route
              path="/booking-details/:groupId"
              exact
              component={GroupDetails}
            />
            <Route
              path="/cafe-panel/:groupId"
              exact
              component={CafePanel}
            />
            <Route path="/group-check-in" component={GroupCheckIn} />
            <Route
              path="/review-photos/:bookingId"
              exact
              component={ReviewPhotos}
            />
            <Route
              path="/staff-details/:staffId"
              exact
              component={StaffDetails}
            />
            <Route
              path="/tenant-details/:tenantId"
              exact
              component={TenantDetails}
            />
            <Route
              path="/room-type-details/:roomTypeId"
              exact
              component={RoomTypeDetails}
            />
            <Route
              path="/tenant-communications/:tenantId"
              exact
              component={Communications}
            />
            <Route
              path="/staff-communications/:staffId"
              exact
              component={Communications}
            />
            <Route path="/search-results" exact component={SearchResults} />
            <Route path="/login" exact component={Login} />
            <Route component={NotFoundScreen} />
          </Switch>{" "}
        </>
      ) : (
        <Switch>
          <Route path="/login" exact component={Login} />
          <Redirect to="/login" />
        </Switch>
      )}
    </>
  );
};

export default App;
